export const Keys = {
    ENTER: 'Enter',
    ESC: 'Esc',
    ESCAPE: 'Escape',
    TAB: 'Tab',
    DELETE: 'Delete',
    BACKSPACE: 'Backspace',
    SHIFT: 'Shift',
    CONTROL: 'Control',
    ALT: 'Alt',
    META: 'Meta',
    ARROW_UP: 'ArrowUp',
    ARROW_RIGHT: 'ArrowRight',
    ARROW_DOWN: 'ArrowDown',
    ARROW_LEFT: 'ArrowLeft',
    HOME: 'Home',
    END: 'End',
    PAGE_UP: 'PageUp',
    PAGE_DOWN: 'PageDown',
    CTRL_BOLD: 'KeyB',
    CTRL_UNDERLINE: 'KeyU',
    CTRL_ITALIC: 'KeyI',
};

export const PREVENT_KEYS = [
    Keys.ENTER,
    Keys.ESC,
    Keys.ESCAPE,
];

export const BLUR_KEYS = [
    Keys.ENTER,
    Keys.ESC,
    Keys.ESCAPE,
    Keys.TAB,
];

export const ERASE_KEYS = [
    Keys.DELETE,
    Keys.BACKSPACE,
];

export const ARROW_KEYS = [
    Keys.ARROW_UP,
    Keys.ARROW_RIGHT,
    Keys.ARROW_DOWN,
    Keys.ARROW_LEFT,
];

export const STYLE_KEYS = [
    Keys.CTRL_BOLD,
    Keys.CTRL_ITALIC,
    Keys.CTRL_UNDERLINE,
];
